module.exports = __webpack_public_path__ + "img/spinomenal.1378fca3.svg";